import React from 'react';
import { Space, Switch, message } from 'antd';
import { useAtom } from 'jotai';
import { panelsAtom } from '../../../atoms';
import { ToggleText, Header } from '../styled';
import { useFeature } from '@src/globalStore/featureStore';
import featureNames from '@src/utils/featureToggle/constants';

function Panels() {
  const [panels, setPanels] = useAtom(panelsAtom);
  const frustrationSignalFeatureEnabled = useFeature(featureNames.DPI_FRUSTRATION_SIGNALS);

  const onToggleCheck =
    (
      panel: 'audience' | 'flows' | 'alerts' | 'frustration' | 'network' | 'percentile' | 'events',
    ) =>
    (checked: boolean) => {
      // Count currently active panels
      const activePanelsCount = Object.values(panels).filter(Boolean).length;

      // If trying to enable a panel and already at max limit (4), prevent it
      if (checked && activePanelsCount >= 4) {
        message.warning('Maximum 4 sections can be active at a time');
        return;
      }

      // Update panels - persistence is handled automatically at the dashboard level
      setPanels({
        ...panels,
        [panel]: checked,
      });
    };

  return (
    <Space direction="vertical">
      <Header>Page Sections</Header>
      <div>
        <Switch size="small" checked={panels.audience} onChange={onToggleCheck('audience')} />
        <ToggleText>Metrics</ToggleText>
      </div>
      <div>
        <Switch size="small" checked={panels.flows} onChange={onToggleCheck('flows')} />
        <ToggleText>Flows</ToggleText>
      </div>
      <div>
        <Switch size="small" checked={panels.events} onChange={onToggleCheck('events')} />
        <ToggleText>Events</ToggleText>
      </div>
      {frustrationSignalFeatureEnabled && (
        <div>
          <Switch
            size="small"
            checked={panels.frustration ?? true}
            onChange={onToggleCheck('frustration')}
          />
          <ToggleText>Frustration Signals</ToggleText>
        </div>
      )}
      <div>
        <Switch
          size="small"
          checked={panels.network ?? false}
          onChange={onToggleCheck('network')}
        />
        <ToggleText>Service Performance</ToggleText>
      </div>
      <div>
        <Switch size="small" checked={panels.alerts} onChange={onToggleCheck('alerts')} />
        <ToggleText>AI Alerts</ToggleText>
      </div>

      {/**<div>
        <Switch
          size="small"
          checked={panels.percentile ?? false}
          onChange={onToggleCheck('percentile')}
        />
        <ToggleText>Percentile</ToggleText>
      </div>*/}
    </Space>
  );
}

export default Panels;
